import * as React from 'react';
const SvgCloseCircleWhite = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 17, fill: "none" }, props),
    React.createElement("circle", { cx: 8, cy: 8.5, r: 8, fill: "#fff" }),
    React.createElement("path", { fill: "#FF66C4", d: "M9.941 11.749 4 5.817 5.303 4.5l5.946 5.941L9.94 11.75Zm-4.638 0L4 10.44 9.941 4.5l1.308 1.317-5.946 5.932Z" })));
export default SvgCloseCircleWhite;
